import React from "react";
import { AboutProductTabProps } from "../../types";
import Image from "next/image";
import { hasArrayElements } from "@/apiUtils/commonUtils";
import NoImageSrc from "@/assets/images/no_image.svg";
import { getCloudinaryURL } from "@/utils/cloudinary";
import CldImage from "@/components/ui/cldImg/CldImage";

const AboutProduct = ({ data, label, id, altText }: AboutProductTabProps & { id?: string }) => {
  const { description, images, ...features } = data;

  return (
    <div
      id={id}
      className="flex h-full flex-col-reverse items-center justify-center max-md:px-5 max-md:py-5 lg:flex-row"
    >
      <div className="flex flex-1 flex-col items-center gap-6 py-5">
        <div className="font-semibold lg:w-[80%]">
          {/* <h2 className="font-semibold md:text-xl">{label}</h2> */}
          <p className="w-full text-sm md:text-base">{data?.description}</p>
          <ul className="ml-5 pt-5">
            {Object?.entries(features)?.map((item, idx) => {
              if (!item || !item[1]) return;
              // return (
              //   <div key={idx} className="flex flex-wrap items-start gap-0 lg:gap-10 text-sm md:text-base">
              //     <span className="inline-flex items-center gap-2">
              //       <span className="h-1 w-1 rounded-full bg-black"></span>
              //       <span>{item[1]}</span>
              //     </span>
              //   </div>
              // );
              return <li key={idx} className="list-disc font-normal">{item[1]}</li>;
            })}
          </ul>
        </div>
      </div>

      <div className="flex h-[9.75rem] w-full flex-1 items-center justify-center md:h-[30.625rem] md:w-[62.75rem]">
        <CldImage
          src={
            hasArrayElements(images) && images[0]
              ? getCloudinaryURL(images[0]?.url)
              : NoImageSrc.src
          }
          alt={altText}
          width={708}
          height={608}
          className="invert-[2%]"
        />
      </div>
    </div>
  );
};

export default AboutProduct;
